import van from "vanjs-core";

const {div, span, img} = van.tags;

export const Logos = () => {
    return (
        div({class: "logos align-items-end d-flex justify-content-end mt-auto"},
            span({class: "me-4 sm-label"}, "powered by"),
            div({class: "vendor-logos"},
                img({src:"/logos/sq_logo.svg",alt:"sq_logo", class:"syneriq"}),
                img({src:"/logos/ist_logo.png",alt:"ist_logo", class:"instar"}),
            ),
            span({class: "mx-4 sm-label"}, "for"),
            img({src:"/logos/lp_logo.svg",alt:"lp_logo"}),
        )
    );
};